export function AlertIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 12 12"
    >
      <g>
        <path
          fill="#0F0F0F"
          fillRule="evenodd"
          d="M5.73.077a.538.538 0 00-.538.539v.538h-.269a2.692 2.692 0 00-2.692 2.692v1.616c0 .397-.126.846-.325 1.3-.197.449-.451.87-.676 1.2-.41.603-.156 1.554.68 1.705.548.099 1.32.216 2.23.292a1.885 1.885 0 103.766-.004 23.91 23.91 0 002.183-.288c.837-.15 1.09-1.102.68-1.705a7.705 7.705 0 01-.675-1.2c-.2-.454-.325-.903-.325-1.3V3.846a2.692 2.692 0 00-2.692-2.692h-.27V.616A.538.538 0 006.27.077h-.538zM6 10.04c.275 0 .545-.006.807-.016a.793.793 0 01-.784.8.792.792 0 01-.784-.798c.248.009.502.014.76.014zM4.923 2.23c-.892 0-1.615.723-1.615 1.615v1.616c0 .605-.186 1.21-.416 1.733a8.783 8.783 0 01-.771 1.372.05.05 0 00-.008.043c.852.153 2.272.352 3.887.352 1.615 0 3.034-.2 3.887-.352a.052.052 0 00-.008-.043 8.782 8.782 0 01-.772-1.372c-.23-.524-.415-1.128-.415-1.733V3.846c0-.892-.723-1.615-1.615-1.615H4.923z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}
